import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/Shell";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/audit?limit=300").then(r => setItems(r.data)).catch(e=>setErr(formatApiError(e))); }, []);
  return (
    <div className="p-4 md:p-8" data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Every important action is logged." />
      {err && <div className="text-rose-600 text-sm mb-3">{err}</div>}
      {items.length === 0 ? <EmptyState title="No audit entries" icon={ScrollText} /> :
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm data-table">
              <thead className="bg-zinc-50"><tr>
                <th className="px-4 py-3 text-left">When</th>
                <th className="px-4 py-3 text-left">User</th>
                <th className="px-4 py-3 text-left">Role</th>
                <th className="px-4 py-3 text-left">Action</th>
                <th className="px-4 py-3 text-left">Entity</th>
                <th className="px-4 py-3 text-left">Entity ID</th>
                <th className="px-4 py-3 text-left">IP</th>
              </tr></thead>
              <tbody>
                {items.map(a => (
                  <tr key={a.id} className="border-t border-zinc-100 hover:bg-zinc-50">
                    <td className="px-4 py-3 num text-xs">{(a.created_at||"").slice(0,19).replace("T"," ")}</td>
                    <td className="px-4 py-3">{a.user_email || "—"}</td>
                    <td className="px-4 py-3 text-zinc-500">{a.user_role}</td>
                    <td className="px-4 py-3 font-semibold">{a.action}</td>
                    <td className="px-4 py-3 text-zinc-500">{a.entity}</td>
                    <td className="px-4 py-3 num text-[10px] text-zinc-500">{a.entity_id}</td>
                    <td className="px-4 py-3 num text-xs text-zinc-400">{a.ip}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      }
    </div>
  );
}
